import "./_operationCommercial.scss";

import {ReactElement} from "react";
import {operationCommercial} from "types/operationCommercial";

import iconDL from "@/assets/iconDownload.svg";
import iconEyes from "@/assets/iconEyes.svg";
import noPicture from "@/assets/iconNoPictureBig.png";
import Button from "@/components/Button/Button";
import {Skeleton} from "@/components/ui/skeleton";
import {formatDate} from "@/function/formatDate";

function OperationCommercial({
  operation,
}: {
  operation: operationCommercial;
}): ReactElement {
  const dateDebut: string = operation?.date_debut
    ? formatDate(operation?.date_debut)
    : "date inconnue";
  const dateFin: string = operation?.date_fin
    ? formatDate(operation?.date_fin)
    : "date inconnue";
  return (
    <div className="operationCommercial operationCommercial-skeleton">
      <img
        src={operation?.image || noPicture}
        alt={`Visuel du catalogue ${operation.nom || operation.identifiant}`}
        loading="lazy"
      />
      <div className="operationCommercial-info">
        <div className="operationCommercial-info-content">
          <h4>{operation.nom || ""}</h4>
          <p>{`Du ${dateDebut} au ${dateFin}`}</p>
          <Button
            label="Consulter"
            icon={iconEyes}
            variant="secondary icon"
            onClick={() => {}}
          />
          <Button
            label="E-catalogue AVEC prix"
            variant="validate icon"
            icon={iconDL}
            onClick={() => {}}
          />
          <Button
            label="E-catalogue SANS prix"
            variant="validate icon"
            icon={iconDL}
            onClick={() => {}}
          />
          <Button
            label="Fichier de sélection"
            variant="validate icon"
            icon={iconDL}
            onClick={() => {}}
          />
          <Button
            label="Modification à noter"
            variant="validate icon"
            icon={iconDL}
            onClick={() => {}}
          />
          <Button
            label="Photo de couverture Facebook - Essentiel Batiment"
            variant="validate icon"
            icon={iconDL}
            onClick={() => {}}
          />

          <Button
            label="Consulter"
            variant="validate icon"
            icon={iconDL}
            onClick={() => {}}
          />

          <Button
            label="Consulter"
            variant="validate icon"
            icon={iconDL}
            onClick={() => {}}
          />

          <Button
            label="Consulter"
            variant="validate icon "
            icon={iconDL}
            onClick={() => {}}
          />
        </div>
      </div>
    </div>
  );
}

function OperationCommercialSkeleton(): ReactElement {
  return <Skeleton className="operationCommercial-skeleton"></Skeleton>;
}

export {OperationCommercial, OperationCommercialSkeleton};
